import { INCOMPLETE_TIME_WINDOW_SUFFIX } from '@modules/charts/components/LineChartWrapper/helpers/getPropertyNameForIncompleteTimeWindow';

export const isIncompleteTimeWindowProperty = (property: string) => {
  return property.includes(INCOMPLETE_TIME_WINDOW_SUFFIX);
};
